import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import BreadCrumb from './shared/BreadCrumb';
import FAQ from './shared/Faq';
import HowTo from './shared/HowTo';
import FooterSection from './shared/FooterSection';
import Templates from './shared/Templates';
import ImageCtaSection from './shared/ImageCta';
import ReadMoreSection from './shared/ReadMore';
import HelpfulLinksSection from './shared/HelpFulLinks';
import InputCta from './shared/InputCta';
import SocialProofSection from './shared/SocialProof';
import FeaturesSection from './shared/Features';
import { Section, Grid, GridItem, Box, Typography, Button, ArrowToRight, Container, Link, Image, Hide } from '@miro-site/ui-core';
import { styled } from '@miro-site/ui-styled-engine';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var HeroSection = styled(Section, {
  backgroundColor: '$yellow-20',
  '@lg': {
    backgroundColor: 'transparent'
  }
});
var HeroSectionWrapper = styled(Box, {
  overflow: 'hidden',
  marginBottom: '$600',
  marginTop: '$300',
  backgroundColor: '$yellow-20',
  '@lg': {
    marginTop: '$400',
    marginBottom: '$800',
    paddingX: '$400',
    marginX: '-$400',
    borderRadius: '$200'
  },
  '.input-cta-wrapper': {
    marginLeft: '0',
    flexDirection: 'column',
    marginBottom: '$400',
    '@md': {
      marginBottom: '0'
    },
    input: {
      height: '46px',
      marginBottom: '$200'
    },
    '@xl': {
      display: 'flex',
      flexDirection: 'row',
      input: {
        marginRight: '$200',
        marginBottom: '0'
      }
    }
  },
  '.image-wrapper': {
    '@md': {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }
});
var ImageWrapperContainer = styled(Container, {
  backgroundColor: '$indigo-90',
  height: '220px',
  overflow: 'hidden',
  position: 'relative',
  marginX: '-$150',
  width: '100vw',
  '@lg': {
    marginX: 0,
    width: 'initial',
    borderRadius: '$100'
  },
  '.svg-wrapper': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%'
  },
  '@sm': {
    height: 'auto',
    maxHeight: '450px'
  },
  '.image-wrapper': {
    position: 'absolute',
    bottom: '0px',
    zIndex: '1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%'
  }
});
var SpotlightBox = styled(Box, {
  backgroundColor: '$yellow-60',
  borderRadius: '$200',
  position: 'relative',
  overflow: 'hidden',
  '.svg-wrapper': {
    position: 'absolute',
    right: 0,
    zindex: 0,
    top: 0,
    width: '30%',
    '@md': {
      width: '40%'
    }
  },
  '.content-wrapper': {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '$400',
    zindex: 10,
    position: 'relative',
    '.upper-part': {
      marginBottom: '$800',
      position: 'relative'
    },
    '@md': {
      width: '50%'
    },
    '@lg': {
      padding: '$800',
      '.upper-part': {
        marginBottom: '$1200'
      }
    }
  }
});
var IntegrateToolsSection = styled(Section, {
  '.logos-wrapper': {
    textAlign: 'center',
    '.tool': {
      display: 'inline-block',
      marginRight: '$200',
      marginBottom: '$200',
      width: '55px',
      '@sm': {
        marginRight: '$400'
      },
      '@lg': {
        marginRight: '$200'
      }
    },
    '@md': {
      '.tool': {
        width: 'auto'
      }
    }
  },
  '.big-outlined-button': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid ',
    borderColor: '$gray-30',
    borderRadius: '$100',
    padding: '$300',
    cursor: 'pointer',
    '@xl': {
      padding: '$400'
    },
    '.button-title': {
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    },
    a: {
      whiteSpace: 'nowrap',
      display: 'flex',
      justifyContent: 'space-between',
      width: '100%',
      '@md': {
        display: 'inline-flex',
        width: 'auto'
      }
    },
    '&:hover': {
      backgroundColor: '$gray-20'
    }
  }
});

var SeoSubUseCase = function SeoSubUseCase(props) {
  var _subUseCaseheroSectio, _subUseCaseheroSectio2, _columnImageSection$i, _columnImageSection$i2, _columnImageSection$c, _columnImageSection$c2, _contentSection$cta, _contentSection$cta2, _spotlightBoxSection$, _spotlightBoxSection$2, _integrateToolsSectio, _integrateToolsSectio2, _integrateToolsSectio3, _integrateToolsSectio4, _integrateToolsSectio5, _integrateToolsSectio6, _integrateToolsSectio7;

  var _ref = props || {},
      subUseCaseheroSection = _ref.subUseCaseheroSection,
      columnImageSection = _ref.columnImageSection,
      spotlightBoxSection = _ref.spotlightBoxSection,
      socialProof = _ref.socialProof,
      howToSection = _ref.howToSection,
      templateSection = _ref.templateSection,
      imageCtaSection = _ref.imageCtaSection,
      faqSection = _ref.faqSection,
      readMoreSection = _ref.readMoreSection,
      helpfulLinksSection = _ref.helpfulLinksSection,
      contentSection = _ref.contentSection,
      footerSection = _ref.footerSection,
      integrateToolsSection = _ref.integrateToolsSection,
      featureSection = _ref.featureSection;

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Container, {
      children: /*#__PURE__*/_jsx(BreadCrumb, {
        homeKeyWord: subUseCaseheroSection === null || subUseCaseheroSection === void 0 ? void 0 : subUseCaseheroSection.homeKeyword
      })
    }), /*#__PURE__*/_jsx(HeroSection, {
      children: /*#__PURE__*/_jsx(HeroSectionWrapper, {
        insetY: {
          '@initial': '600',
          '@lg': '800'
        },
        children: /*#__PURE__*/_jsxs(Grid, {
          css: {
            gridRowGap: '0'
          },
          children: [/*#__PURE__*/_jsxs(GridItem, {
            columnStart: "1",
            columnEnd: {
              '@initial': -1,
              '@md': 7
            },
            css: {
              textAlign: 'center',
              '@md': {
                paddingRight: '$400',
                textAlign: 'left'
              }
            },
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "heading-1",
              type: "heading",
              tag: "h1",
              offsetBottom: "stacking-300",
              renderChildrenAsHTML: true,
              children: (subUseCaseheroSection === null || subUseCaseheroSection === void 0 ? void 0 : subUseCaseheroSection.title) || ''
            }), /*#__PURE__*/_jsx(Typography, {
              variant: "body-text-1",
              offsetBottom: "stacking-400",
              renderChildrenAsHTML: true,
              children: (subUseCaseheroSection === null || subUseCaseheroSection === void 0 ? void 0 : subUseCaseheroSection.subTitle) || ''
            }), /*#__PURE__*/_jsx("div", {
              className: "input-cta-wrapper",
              children: /*#__PURE__*/_jsx(InputCta, {
                cta: subUseCaseheroSection === null || subUseCaseheroSection === void 0 ? void 0 : subUseCaseheroSection.cta,
                placeholder: subUseCaseheroSection === null || subUseCaseheroSection === void 0 ? void 0 : subUseCaseheroSection.inputPlaceHolder
              })
            })]
          }), /*#__PURE__*/_jsx(GridItem, {
            columnStart: {
              '@initial': 1,
              '@md': 7
            },
            columnEnd: "-1",
            css: {
              position: 'relative'
            },
            asChild: true,
            children: /*#__PURE__*/_jsx("div", {
              className: "image-wrapper",
              children: (subUseCaseheroSection === null || subUseCaseheroSection === void 0 ? void 0 : (_subUseCaseheroSectio = subUseCaseheroSection.image) === null || _subUseCaseheroSectio === void 0 ? void 0 : (_subUseCaseheroSectio2 = _subUseCaseheroSectio.desktop) === null || _subUseCaseheroSectio2 === void 0 ? void 0 : _subUseCaseheroSectio2.src) && /*#__PURE__*/_jsx(Image, {
                image: subUseCaseheroSection.image.desktop
              })
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(SocialProofSection, _objectSpread({}, socialProof)), /*#__PURE__*/_jsxs(Section, {
      pageTopInset: "1200",
      children: [/*#__PURE__*/_jsx(Box, {
        offsetTop: {
          '@initial': '400',
          '@xs': '50',
          '@md': '400'
        },
        children: /*#__PURE__*/_jsx(Grid, {
          children: /*#__PURE__*/_jsxs(GridItem, {
            columnStart: {
              '@initial': 1,
              '@md': 3,
              '@xxl': 4
            },
            columnEnd: {
              '@initial': -1,
              '@md': 11,
              '@xxl': 10
            },
            children: [/*#__PURE__*/_jsx(Typography, {
              align: "center",
              variant: "heading-2",
              offsetBottom: "stacking-300",
              renderChildrenAsHTML: true,
              children: (columnImageSection === null || columnImageSection === void 0 ? void 0 : columnImageSection.title) || ''
            }), /*#__PURE__*/_jsx(Typography, {
              align: "center",
              offsetBottom: {
                '@initial': '600',
                '@lg': '800'
              },
              variant: "body-text-1",
              renderChildrenAsHTML: true,
              children: (columnImageSection === null || columnImageSection === void 0 ? void 0 : columnImageSection.subTitle) || ''
            })]
          })
        })
      }), /*#__PURE__*/_jsxs(ImageWrapperContainer, {
        disableGutter: true,
        children: [/*#__PURE__*/_jsx("div", {
          className: "svg-wrapper",
          children: /*#__PURE__*/_jsx("svg", {
            width: "1132",
            height: "406",
            viewBox: "0 0 1132 406",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/_jsx("path", {
              d: "M56.6686 651.927C157.27 624.971 141.382 565.678 241.984 538.722C342.585 511.766 358.473 571.059 459.074 544.103C559.676 517.147 543.788 457.854 644.389 430.898C744.78 403.999 760.667 463.291 861.269 436.335C961.87 409.379 945.983 350.086 1046.58 323.13C1147.19 296.174 1163.07 355.467 1263.67 328.511L1140.6 -154.431C1074.89 -124.643 1076.08 -76.3457 987.919 -52.7238C887.317 -25.7678 871.43 -85.0607 770.828 -58.1046C670.227 -31.1485 686.115 28.1443 585.513 55.1004C485.123 81.9999 469.235 22.707 368.634 49.6631C268.033 76.6192 283.92 135.912 183.319 162.868C82.7172 189.824 66.8298 130.531 -33.7715 157.487C-46.4258 160.878 -57.1545 164.706 -66.406 168.986L56.6686 651.927Z",
              fill: "#4262FF"
            })
          })
        }), /*#__PURE__*/_jsx(Grid, {
          children: /*#__PURE__*/_jsx(GridItem, {
            xs: 12,
            children: /*#__PURE__*/_jsx("div", {
              className: "image-wrapper",
              children: (columnImageSection === null || columnImageSection === void 0 ? void 0 : (_columnImageSection$i = columnImageSection.image) === null || _columnImageSection$i === void 0 ? void 0 : (_columnImageSection$i2 = _columnImageSection$i.desktop) === null || _columnImageSection$i2 === void 0 ? void 0 : _columnImageSection$i2.src) && /*#__PURE__*/_jsx(Image, {
                image: columnImageSection.image.desktop
              })
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Grid, {
        children: /*#__PURE__*/_jsx(GridItem, {
          xs: 12,
          centerEvenSizedColumn: true,
          children: /*#__PURE__*/_jsx(Button, {
            appearance: "filled",
            endIcon: /*#__PURE__*/_jsx(ArrowToRight, {}),
            rounded: true,
            size: "large",
            variant: "primary",
            css: {
              marginTop: '$300'
            },
            href: columnImageSection === null || columnImageSection === void 0 ? void 0 : (_columnImageSection$c = columnImageSection.cta) === null || _columnImageSection$c === void 0 ? void 0 : _columnImageSection$c.href,
            children: columnImageSection === null || columnImageSection === void 0 ? void 0 : (_columnImageSection$c2 = columnImageSection.cta) === null || _columnImageSection$c2 === void 0 ? void 0 : _columnImageSection$c2.text
          })
        })
      })]
    }), /*#__PURE__*/_jsx(FeaturesSection, _objectSpread({}, featureSection)), /*#__PURE__*/_jsx(Section, {
      pageTopInset: "1200",
      children: /*#__PURE__*/_jsx(Box, {
        offsetTop: {
          '@initial': '400',
          '@xs': '50',
          '@md': '400'
        },
        children: /*#__PURE__*/_jsxs(Grid, {
          children: [/*#__PURE__*/_jsx(GridItem, {
            columnStart: "1",
            columnEnd: {
              '@initial': -1,
              '@md': 7,
              '@xxl': 6
            },
            children: /*#__PURE__*/_jsx(Typography, {
              variant: "heading-3",
              renderChildrenAsHTML: true,
              children: (contentSection === null || contentSection === void 0 ? void 0 : contentSection.title) || ''
            })
          }), /*#__PURE__*/_jsxs(GridItem, {
            columnStart: {
              '@initial': 1,
              '@md': 8,
              '@xxl': 7
            },
            columnEnd: "-1",
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "body-text-1",
              renderChildrenAsHTML: true,
              children: (contentSection === null || contentSection === void 0 ? void 0 : contentSection.content) || ''
            }), (contentSection === null || contentSection === void 0 ? void 0 : contentSection.cta) && /*#__PURE__*/_jsx(Button, {
              appearance: "filled",
              endIcon: /*#__PURE__*/_jsx(ArrowToRight, {}),
              rounded: true,
              size: "large",
              variant: "primary",
              css: {
                marginTop: '$300'
              },
              href: contentSection === null || contentSection === void 0 ? void 0 : (_contentSection$cta = contentSection.cta) === null || _contentSection$cta === void 0 ? void 0 : _contentSection$cta.href,
              children: contentSection === null || contentSection === void 0 ? void 0 : (_contentSection$cta2 = contentSection.cta) === null || _contentSection$cta2 === void 0 ? void 0 : _contentSection$cta2.text
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Section, {
      pageTopInset: "1200",
      children: /*#__PURE__*/_jsx(Grid, {
        children: /*#__PURE__*/_jsx(GridItem, {
          xs: 12,
          children: /*#__PURE__*/_jsx(SpotlightBox, {
            children: /*#__PURE__*/_jsx(Grid, {
              disableGutter: true,
              children: /*#__PURE__*/_jsxs(GridItem, {
                xs: 12,
                children: [/*#__PURE__*/_jsx("div", {
                  className: "svg-wrapper",
                  children: /*#__PURE__*/_jsxs("svg", {
                    width: "605",
                    height: "452",
                    viewBox: "0 0 605 452",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [/*#__PURE__*/_jsx("path", {
                      d: "M146.978 229.241V451.981L96.3355 452L51.3232 248.141L146.978 229.241Z",
                      fill: "#FDF1C6"
                    }), /*#__PURE__*/_jsx("path", {
                      d: "M102.427 16.9841L0.219727 16.9655L52.263 250.207L102.427 240.29V16.9841Z",
                      fill: "#FDF1C6"
                    }), /*#__PURE__*/_jsx("path", {
                      d: "M98.4956 16.984V239.724L195.461 220.614L144.212 16.9655L98.4956 16.984Z",
                      fill: "#FDF1C6"
                    }), /*#__PURE__*/_jsx("path", {
                      d: "M286.058 325.031C279.983 354.704 250.919 373.416 221.139 366.812C191.36 360.239 172.163 330.844 178.239 301.171C184.344 271.498 213.407 252.801 243.172 259.39C272.952 265.963 292.148 295.358 286.058 325.031Z",
                      fill: "#FDF1C6"
                    }), /*#__PURE__*/_jsx("path", {
                      d: "M386.772 163.724V416.602L336.564 416.62L284.565 183.906L386.772 163.724Z",
                      fill: "#FDF1C6"
                    }), /*#__PURE__*/_jsx("path", {
                      d: "M234.479 161.103L184.979 -42H281.944V151.65L234.479 161.103Z",
                      fill: "#FDF1C6"
                    }), /*#__PURE__*/_jsx("path", {
                      d: "M336.9 141.225L381.53 -42H281.944V151.931L336.9 141.225Z",
                      fill: "#FDF1C6"
                    }), /*#__PURE__*/_jsx("path", {
                      d: "M47.0433 407.209C45.1628 416.394 36.167 422.185 26.9495 420.141C17.7319 418.107 11.7902 409.008 13.6706 399.824C15.5604 390.639 24.5561 384.852 33.7691 386.892C42.9866 388.926 48.9284 398.024 47.0433 407.209Z",
                      fill: "#FDF1C6"
                    }), /*#__PURE__*/_jsx("path", {
                      d: "M660.461 283.634V123.76L590.863 137.476L627.648 283.648L660.461 283.634Z",
                      fill: "#FDF1C6"
                    }), /*#__PURE__*/_jsx("path", {
                      d: "M453.548 178.31V-3.196L489.585 -3.20937L526.908 163.824L453.548 178.31Z",
                      fill: "#FDF1C6"
                    }), /*#__PURE__*/_jsx("path", {
                      d: "M562.858 180.191L598.387 325.971H528.789V186.976L562.858 180.191Z",
                      fill: "#FDF1C6"
                    }), /*#__PURE__*/_jsx("path", {
                      d: "M489.344 194.459L457.31 325.971H528.789V186.775L489.344 194.459Z",
                      fill: "#FDF1C6"
                    })]
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: "content-wrapper",
                  children: [/*#__PURE__*/_jsxs("div", {
                    className: "upper-part",
                    children: [(spotlightBoxSection === null || spotlightBoxSection === void 0 ? void 0 : (_spotlightBoxSection$ = spotlightBoxSection.image) === null || _spotlightBoxSection$ === void 0 ? void 0 : (_spotlightBoxSection$2 = _spotlightBoxSection$.desktop) === null || _spotlightBoxSection$2 === void 0 ? void 0 : _spotlightBoxSection$2.src) != '' && /*#__PURE__*/_jsx(Image, {
                      image: spotlightBoxSection.image.desktop
                    }), /*#__PURE__*/_jsx(Typography, {
                      tag: "p",
                      type: "heading",
                      offsetTop: {
                        '@initial': '300',
                        '@lg': '400'
                      },
                      variant: "heading-3",
                      renderChildrenAsHTML: true,
                      children: (spotlightBoxSection === null || spotlightBoxSection === void 0 ? void 0 : spotlightBoxSection.quote) || ''
                    })]
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "bottom-part",
                    children: [/*#__PURE__*/_jsx(Typography, {
                      variant: "sub-heading-1",
                      renderChildrenAsHTML: true,
                      children: (spotlightBoxSection === null || spotlightBoxSection === void 0 ? void 0 : spotlightBoxSection.name) || ''
                    }), /*#__PURE__*/_jsx(Typography, {
                      variant: "body-text-1",
                      renderChildrenAsHTML: true,
                      children: (spotlightBoxSection === null || spotlightBoxSection === void 0 ? void 0 : spotlightBoxSection.designation) || ''
                    })]
                  })]
                })]
              })
            })
          })
        })
      })
    }), /*#__PURE__*/_jsxs(IntegrateToolsSection, {
      pageTopInset: "1200",
      children: [/*#__PURE__*/_jsx(Grid, {
        css: {
          gridRowGap: '0'
        },
        children: /*#__PURE__*/_jsxs(GridItem, {
          columnStart: {
            '@initial': 1,
            '@md': 3
          },
          columnEnd: {
            '@initial': -1,
            '@md': 11
          },
          children: [/*#__PURE__*/_jsx(Typography, {
            align: "center",
            variant: "heading-2",
            tag: "h3",
            type: "heading",
            offsetBottom: {
              '@initial': '200',
              '@sm': '300'
            },
            renderChildrenAsHTML: true,
            children: (integrateToolsSection === null || integrateToolsSection === void 0 ? void 0 : integrateToolsSection.title) || ''
          }), /*#__PURE__*/_jsx(Typography, {
            align: "center",
            variant: "body-text-1",
            offsetBottom: {
              '@initial': '600',
              '@lg': '800'
            },
            renderChildrenAsHTML: true,
            children: (integrateToolsSection === null || integrateToolsSection === void 0 ? void 0 : integrateToolsSection.subTitle) || ''
          })]
        })
      }), /*#__PURE__*/_jsx(Grid, {
        children: /*#__PURE__*/_jsx(GridItem, {
          xs: 12,
          children: (integrateToolsSection === null || integrateToolsSection === void 0 ? void 0 : (_integrateToolsSectio = integrateToolsSection.logos) === null || _integrateToolsSectio === void 0 ? void 0 : _integrateToolsSectio.length) && /*#__PURE__*/_jsx("div", {
            className: "logos-wrapper",
            children: integrateToolsSection.logos.map(function (tool, index) {
              var _tool$logo;

              return /*#__PURE__*/_jsx("div", {
                className: "tool",
                children: /*#__PURE__*/_jsx(Image, {
                  image: tool === null || tool === void 0 ? void 0 : (_tool$logo = tool.logo) === null || _tool$logo === void 0 ? void 0 : _tool$logo.desktop
                })
              }, 'tool-' + index);
            })
          })
        })
      }), /*#__PURE__*/_jsx(Grid, {
        children: /*#__PURE__*/_jsx(GridItem, {
          columnStart: {
            '@initial': 1,
            '@md': 4
          },
          columnEnd: {
            '@initial': -1,
            '@md': 10
          },
          children: /*#__PURE__*/_jsx(Typography, {
            offsetBottom: {
              '@initial': '600',
              '@lg': '800'
            },
            align: "center",
            variant: "body-text-1",
            renderChildrenAsHTML: true,
            children: (integrateToolsSection === null || integrateToolsSection === void 0 ? void 0 : integrateToolsSection.logoSubText) || ''
          })
        })
      }), /*#__PURE__*/_jsxs(Grid, {
        children: [/*#__PURE__*/_jsx(GridItem, {
          xs: 12,
          md: 6,
          children: /*#__PURE__*/_jsxs("a", {
            href: integrateToolsSection === null || integrateToolsSection === void 0 ? void 0 : (_integrateToolsSectio2 = integrateToolsSection.cta1) === null || _integrateToolsSectio2 === void 0 ? void 0 : _integrateToolsSectio2.href,
            className: "big-outlined-button",
            children: [/*#__PURE__*/_jsx(Hide, {
              upTo: "md",
              children: /*#__PURE__*/_jsx(Typography, {
                className: "button-title",
                variant: "sub-heading-1",
                renderChildrenAsHTML: true,
                children: (integrateToolsSection === null || integrateToolsSection === void 0 ? void 0 : integrateToolsSection.firstCtaTitle) || ''
              })
            }), /*#__PURE__*/_jsx(Link, {
              href: integrateToolsSection === null || integrateToolsSection === void 0 ? void 0 : (_integrateToolsSectio3 = integrateToolsSection.cta1) === null || _integrateToolsSectio3 === void 0 ? void 0 : _integrateToolsSectio3.href,
              endIcon: /*#__PURE__*/_jsx(ArrowToRight, {}),
              children: integrateToolsSection === null || integrateToolsSection === void 0 ? void 0 : (_integrateToolsSectio4 = integrateToolsSection.cta1) === null || _integrateToolsSectio4 === void 0 ? void 0 : _integrateToolsSectio4.text
            })]
          })
        }), /*#__PURE__*/_jsx(GridItem, {
          xs: 12,
          md: 6,
          children: /*#__PURE__*/_jsxs("a", {
            href: integrateToolsSection === null || integrateToolsSection === void 0 ? void 0 : (_integrateToolsSectio5 = integrateToolsSection.cta2) === null || _integrateToolsSectio5 === void 0 ? void 0 : _integrateToolsSectio5.href,
            className: "big-outlined-button",
            children: [/*#__PURE__*/_jsx(Hide, {
              upTo: "md",
              children: /*#__PURE__*/_jsx(Typography, {
                className: "button-title",
                variant: "sub-heading-1",
                renderChildrenAsHTML: true,
                children: (integrateToolsSection === null || integrateToolsSection === void 0 ? void 0 : integrateToolsSection.secondCtaTitle) || ''
              })
            }), /*#__PURE__*/_jsx(Link, {
              href: integrateToolsSection === null || integrateToolsSection === void 0 ? void 0 : (_integrateToolsSectio6 = integrateToolsSection.cta2) === null || _integrateToolsSectio6 === void 0 ? void 0 : _integrateToolsSectio6.href,
              className: "internal-link",
              endIcon: /*#__PURE__*/_jsx(ArrowToRight, {}),
              children: integrateToolsSection === null || integrateToolsSection === void 0 ? void 0 : (_integrateToolsSectio7 = integrateToolsSection.cta2) === null || _integrateToolsSectio7 === void 0 ? void 0 : _integrateToolsSectio7.text
            })]
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(HowTo, _objectSpread({}, howToSection)), /*#__PURE__*/_jsx(Templates, _objectSpread({}, templateSection)), /*#__PURE__*/_jsx(ImageCtaSection, {
      props: imageCtaSection
    }), /*#__PURE__*/_jsx(FAQ, _objectSpread({}, faqSection)), /*#__PURE__*/_jsx(ReadMoreSection, _objectSpread({}, readMoreSection)), /*#__PURE__*/_jsx(HelpfulLinksSection, _objectSpread({}, helpfulLinksSection)), /*#__PURE__*/_jsx(FooterSection, _objectSpread({}, footerSection))]
  });
};

export default SeoSubUseCase;